import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { SectionReveal } from './SectionReveal';
export function GuaranteeSection() {
  return <section className="py-20 bg-[#0a0a0a] border-b border-[#262626]" data-id="element-97">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center" data-id="element-98">
        <SectionReveal data-id="element-99">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-[#171717] border border-[#262626] rounded-full mb-6" data-id="element-100">
            <ShieldCheck className="w-10 h-10 text-[#F59E0B]" data-id="element-101" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-102">
            Garantía de 7 Días
          </h2>
          <p className="text-lg text-[#9CA3AF] leading-relaxed" data-id="element-103">
            Si el material no cumple tus expectativas, podés solicitar la
            devolución dentro del período establecido.
          </p>
        </SectionReveal>
      </div>
    </section>;
}